/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * トップページに表示される新話が公開されているポップアップ
 * @export
 * @interface NewArticlePopupModel
 */
export interface NewArticlePopupModel {
    /**
     * 
     * @type {number}
     * @memberof NewArticlePopupModel
     */
    userPopupNewArticleId?: number;
    /**
     * エピソードのID
     * @type {number}
     * @memberof NewArticlePopupModel
     */
    articleId?: number;
    /**
     * エピソードのタイトル
     * @type {string}
     * @memberof NewArticlePopupModel
     */
    articleTitle?: string;
    /**
     * 
     * @type {number}
     * @memberof NewArticlePopupModel
     */
    userId?: number;
    /**
     * ユーザーの名
     * @type {string}
     * @memberof NewArticlePopupModel
     */
    userName?: string;
    /**
     * ユーザータイプにより、ポップアップの内容が異なる
     * @type {number}
     * @memberof NewArticlePopupModel
     */
    userType?: number;
    /**
     * 該当するエピソードを含めている作品名
     * @type {string}
     * @memberof NewArticlePopupModel
     */
    seriesName?: string;
    /**
     * 該当するエピソードを含めている作品のID
     * @type {number}
     * @memberof NewArticlePopupModel
     */
    seriesId?: number;
    /**
     * サイトではレンタルかどうかのフラグ
     * @type {boolean}
     * @memberof NewArticlePopupModel
     */
    isRental?: boolean;
    /**
     * エピソードのリンク先
     * @type {string}
     * @memberof NewArticlePopupModel
     */
    episodeUrl?: string;
    /**
     * エピソードの画像リンク先（大きいサイズ）
     * @type {string}
     * @memberof NewArticlePopupModel
     */
    largeImageUrl?: string;
    /**
     * エピソードの画像リンク先（小さいサイズ）
     * @type {string}
     * @memberof NewArticlePopupModel
     */
    smallImageUrl?: string;
    /**
     * エピソードのサムネイル画像リンク先
     * @type {string}
     * @memberof NewArticlePopupModel
     */
    thumbnailImageUrl?: string;
}

/**
 * Check if a given object implements the NewArticlePopupModel interface.
 */
export function instanceOfNewArticlePopupModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NewArticlePopupModelFromJSON(json: any): NewArticlePopupModel {
    return NewArticlePopupModelFromJSONTyped(json, false);
}

export function NewArticlePopupModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewArticlePopupModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userPopupNewArticleId': !exists(json, 'userPopupNewArticleId') ? undefined : json['userPopupNewArticleId'],
        'articleId': !exists(json, 'articleId') ? undefined : json['articleId'],
        'articleTitle': !exists(json, 'articleTitle') ? undefined : json['articleTitle'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'userType': !exists(json, 'userType') ? undefined : json['userType'],
        'seriesName': !exists(json, 'seriesName') ? undefined : json['seriesName'],
        'seriesId': !exists(json, 'seriesId') ? undefined : json['seriesId'],
        'isRental': !exists(json, 'isRental') ? undefined : json['isRental'],
        'episodeUrl': !exists(json, 'episodeUrl') ? undefined : json['episodeUrl'],
        'largeImageUrl': !exists(json, 'largeImageUrl') ? undefined : json['largeImageUrl'],
        'smallImageUrl': !exists(json, 'smallImageUrl') ? undefined : json['smallImageUrl'],
        'thumbnailImageUrl': !exists(json, 'thumbnailImageUrl') ? undefined : json['thumbnailImageUrl'],
    };
}

export function NewArticlePopupModelToJSON(value?: NewArticlePopupModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userPopupNewArticleId': value.userPopupNewArticleId,
        'articleId': value.articleId,
        'articleTitle': value.articleTitle,
        'userId': value.userId,
        'userName': value.userName,
        'userType': value.userType,
        'seriesName': value.seriesName,
        'seriesId': value.seriesId,
        'isRental': value.isRental,
        'episodeUrl': value.episodeUrl,
        'largeImageUrl': value.largeImageUrl,
        'smallImageUrl': value.smallImageUrl,
        'thumbnailImageUrl': value.thumbnailImageUrl,
    };
}

